const enUS = {
  "commom.confirm.delete": "Are you sure you want to delete?",
  "common.accept": "Accept",
  "common.access.control": "Access Control",
  "common.action.not.allowed": "Action Not Allowed",
  "common.action.not.allowedMessage": "You do not have permission to perform this action.",
  "common.action": "Action",
  "common.actions": "Actions",
  "common.active": "Active",
  "common.activity": "Activity",
  "common.add.to.filter": "Add to filter",
  "common.add.to.list": "Add to list",
  "common.add": "Add",
  "common.administrators": "Administrators",
  "common.all": "All",
  "common.all.devices": "All Devices",
  "common.allow.all": "Allow All",
  "common.allow": "Allow",
  "common.allowed": "Allowed",
  "common.alloweds": "Allowed",
  "common.alreadyExists": "Already exists",
  "common.always": "Always",
  "common.any": "Any",
  "common.api_settings": "API Settings",
  "common.apis": "APIs",
  "common.application": "Application",
  "common.apply": "Apply",
  "common.archive": "Archive",
  "common.at.day": "Day",
  "common.at.hours": "at",
  "common.attack": "Attack",
  "common.audit.log": "Audit Log",
  "common.audit": "Audit",
  "common.auditor": "Auditor",
  "common.auth.servers": "Authentication Servers",
  "common.auth": "Authenticated",
  "common.authenticated": "Authenticated",
  "common.authentication.required": "MFA field is required",
  "common.authentication": "Authentication",
  "common.authorization.settings": "Authorization Settings",
  "common.back.to.home": "Back to Home",
  "common.back.to.previous": "Back to Previous",
  "common.back": "Back",
  "common.backup": "Backup",
  "common.backups": "Backups",
  "common.balancing": "Balancing",
  "common.bandwidth": "Bandwidth",
  "common.blacklist": "Blocked Addresses",
  "common.block_all": "Block All",
  "common.block": "Block",
  "common.ha": "High Availability Enabled",
  "common.blocked.access": "Blocked Access",
  "common.blocked": "Blocked",
  "common.blockeds": "Blocked",
  "common.bytes.received": "Bytes Received",
  "common.bytes.sent": "Bytes Sent",
  "common.bytes.total": "Total Bytes",
  "common.bytes": "Bytes",
  "common.cancel.action": "Cancel Action",
  "common.cancel": "Cancel",
  "common.category": "Category",
  "common.certificate.remote": "Remote CA",
  "common.certificate": "Certificate",
  "common.certificates": "Certificates",
  "common.change": "Change",
  "common.city": "City",
  "common.clear": "Clear",
  "common.client": "Client",
  "common.clone.error": "Error cloning",
  "common.clone.success": "Successfully cloned",
  "common.clone": "Clone",
  "common.close": "Close",
  "common.collapse": "Collapse",
  "common.community": "Device Community",
  "common.company": "Company",
  "common.completed": "Complete",
  "common.conditions": "Conditions",
  "common.config": "Configuration",
  "common.configure": "Configure",
  "common.confirm.action": "Confirm Action",
  "common.confirm.changes": "Confirm Changes",
  "common.confirm.Delete": "Confirm Deletion",
  "common.confirm.ok": "Confirm",
  "common.confirmation": "Confirmation",
  "common.connect": "Connected",
  "common.connection.error": "Connection Error",
  "common.connection.lost.message": "The connection to the server was lost. Please check your internet connection and try again.",
  "common.connection.lost": "Connection Lost",
  "common.connection": "Connection",
  "common.connections": "Connections",
  "common.continue": "Continue",
  "common.controls": "Controls",
  "common.copied": "Copied",
  "common.copy": "Copy",
  "common.country": "Country",
  "common.create.name": "Create {name}",
  "common.create": "Create",
  "common.created": "Created",
  "common.custom-signature": "Customized Signature",
  "common.customize": "Customize",
  "common.dashboard": "Dashboard",
  "common.data.Loading.error": "Error Loading Data",
  "common.data.Loading.errorMessage": "There was a problem loading the data. Please try again.",
  "common.date": "Date",
  "common.days": "Days",
  "common.decline": "Decline",
  "common.declined": "Declined",
  "common.default": "Default",
  "common.del.to.list": "Remove from list",
  "common.delete.confirmation.multiple": "Are you sure you want to delete the selected items?",
  "common.delete.confirmation": "Are you sure you want to delete?",
  "common.delete.name": "Delete {name}",
  "common.delete.select": "Delete selected",
  "common.delete.success": "Successfully removed",
  "common.delete": "Delete",
  "common.deleted": "{name} successfully deleted",
  "common.denied": "Denied",
  "common.deny_all": "Deny All",
  "common.deny": "Deny",
  "common.deploy": "Deploy",
  "common.description": "Description",
  "common.deselect.all": "Deselect All",
  "common.destination": "Destination",
  "common.details": "Details",
  "common.devComm": "Device Community",
  "common.device": "Device",
  "common.deviceLogger": "Device/Logger",
  "common.devin": "Device",
  "common.devTemplate": "Device Template",
  "common.dhcp": "DHCP",
  "common.diff": "Differential",
  "common.directory": "Directory",
  "common.disable_all": "Disable All",
  "common.disable.all": "Deactivate All",
  "common.disable": "Disable",
  "common.disabled.success": "Successfully disabled",
  "common.disabled": "Disabled",
  "common.disableds": "Disabled",
  "common.disc": "Disc",
  "common.discard.changes": "Discard Changes",
  "common.disclaimer.login.title": "Login Disclaimer",
  "common.disclaimer": "Disclaimer",
  "common.disk": "Disk",
  "common.dns_server": "DNS Server",
  "common.dns": "DNS",
  "common.dnsServer": "DNS Server",
  "common.dnssuffix": "DNS Suffix",
  "common.domain": "Domain",
  "common.done": "Completed",
  "common.dont.permission.clone": "You do not have permission to clone this record.",
  "common.dont.permission.delete": "You do not have permission to delete this record.",
  "common.dont.permission.edit": "You do not have permission to edit this record.",
  "common.dont.permission.page": "You do not have permission to access this page.",
  "common.dont.permission": "You do not have permission to perform this action.",
  "common.dst": "Destination",
  "common.duration": "Duration",
  "common.edit": "Edit",
  "common.email.report": "Send Report by Email",
  "common.email": "Email",
  "common.enable.all": "Activate All",
  "common.enable": "Enable",
  "common.enabled": "Enabled",
  "common.english": "English",
  "common.error.character": "Invalid character.",
  "common.error.email": "{name} must be a valid email.",
  "common.error.fetch": "Error fetching data.",
  "common.error.file.notfound": "File not found",
  "common.error.invalid.format.core.max": "Value above the limit, maximum allowed",
  "common.error.invalid.format.core.min": "Value below the limit, minimum allowed",
  "common.error.invalid.format": "Invalid format",
  "common.error.invalid.value": "Invalid value",
  "common.error.invalid": "{name} is invalid",
  "common.error.min.character": "The field must have at least {number} characters.",
  "common.error.network": "Network error!",
  "common.error.required.advancedSettings": "Value is required",
  "common.error.required.ip.forwarding": "IP is required",
  "common.error.required": "{name} is required",
  "common.error.saml.service.name": "SAML Service Name is required",
  "common.error.snap.version": "Unsupported Snap version",
  "common.error.url.fail": "Invalid URL.",
  "common.error.url.https": "This URL must be of the https type.",
  "common.error.url": "{name} must be a valid URL.",
  "common.error.version": "Unsupported version",
  "common.error": "Error",
  "common.established": "Established",
  "common.event": "Event",
  "common.exception": "Exception",
  "common.expand": "Expand",
  "common.expires": "Expires in (years)",
  "common.failed": "Failed",
  "common.filial": "Branch",
  "common.filter": "Filter",
  "common.filters": "Filters",
  "common.firewall": "Firewall",
  "common.first": "First",
  "common.gateway": "Gateway",
  "common.general": "General",
  "common.generic.error.message": "An error occurred. Please try again later.",
  "common.generic.error": "Generic Error",
  "common.github": "GitHub",
  "common.group": "Group",
  "common.groups": "Groups",
  "common.hide": "Hide",
  "common.high.availability": "High Availability",
  "common.high": "High",
  "common.highAvailability": "High Availability",
  "common.hits": "Hits",
  "common.host": "Host",
  "common.hostname": "Hostname",
  "common.hours": "Hours",
  "common.id": "ID",
  "common.identification": "Identification",
  "common.identity.provider": "Identity Provider",
  "common.idle": "Idle",
  "common.import-file": "Import File",
  "common.import": "Import {name}",
  "common.inactive": "Inactive",
  "common.information": "Information",
  "common.informations": "Informations",
  "common.initial.space.error": "Initial space is not allowed",
  "common.inspection": "Inspection",
  "common.integrated": "Integrated",
  "common.integration.settings": "Integration Settings",
  "common.interface": "Interface",
  "common.interfaces": "Interfaces",
  "common.invalid.fields": "Invalid Fields",
  "common.invalid.form": "Please review this form!",
  "common.invalid.Format.message": "The entered format is invalid. Please enter a valid format.",
  "common.invalid.Format": "Invalid Format",
  "common.invalid.input.message": "Please provide a valid input.",
  "common.invalid.input": "Invalid Input",
  "common.invalid.Request": "Invalid Request",
  "common.invalid.value": "Invalid value!",
  "common.ip": "IP",
  "common.ipAddress": "IP Address",
  "common.ipExample": "1.1.1.1",
  "common.ips": "IPs",
  "common.items.not.found": "No items found",
  "common.jitter": "Jitter",
  "common.key": "Key",
  "common.language": "Language",
  "common.latency": "Latency",
  "common.Lease": "Leases",
  "common.license.expires.at": "License will expire on:",
  "common.license": "License",
  "common.limit.profile": "Limit of created profiles.",
  "common.linkedin": "LinkedIn",
  "common.list": "List",
  "common.loading": "Loading",
  "common.local": "Local",
  "common.logger": "Logger",
  "common.logging": "Logging",
  "common.login.form.email.required": "E-mail is required",
  "common.login.form.email": "E-mail Address",
  "common.login.form.forgot": "Forgot password?",
  "common.login.form.password.required": "Password is required",
  "common.login.form.password": "Password",
  "common.login.form": "Access your account",
  "common.login": "Login",
  "common.logs": "Logs",
  "common.logtype": "Log Type",
  "common.low": "Low",
  "common.mac": "MAC",
  "common.malicious": "Malicious IP",
  "common.malware": "Malware",
  "common.manager.delete.group.message.withdevice": "Are you sure you want to delete the group? This operation cannot be reversed.",
  "common.manager.delete.group.message": "Are you sure you want to delete the group?",
  "common.mask": "Mask",
  "common.master": "Headquarters",
  "common.max": "Max",
  "common.medium": "Medium",
  "common.minFile": "Minimum file size (MB)",
  "common.minutes": "Minutes",
  "common.mode": "Mode",
  "common.model": "Model",
  "common.modules": "Modules",
  "common.months": "Months",
  "common.multifactor.acronym": "MFA",
  "common.multifactor.active": "Two-Factor Identification",
  "common.multifactor.authentication": "Multi-Factor Authentication",
  "common.multifactor.validate": "User with registered key",
  "common.name.already.exists": "Profile name already exists!",
  "common.name": "Name",
  "common.network": "Network",
  "common.new": "New",
  "common.next": "Next",
  "common.no.results.found.message": "No results were found for your search.",
  "common.no.results.found": "No Results Found",
  "common.not.Authorized": "Not Authorized",
  "common.no": "No",
  "common.no.group": "No Group",
  "common.none": "None",
  "common.nothing.delete": "No item to delete",
  "common.notifications": "Notifications",
  "common.ntp.server": "NTP Server",
  "common.object.address": "Address",
  "common.object.content": "Content",
  "common.object.dictionary": "Dictionary",
  "common.object.schedule": "Schedule",
  "common.object.service": "Service",
  "common.object.time": "Time",
  "common.ok": "Ok",
  "common.operation.failed.message": "The requested operation failed. Please try again.",
  "common.operation.failed": "Operation Failed",
  "common.organization": "Organization",
  "common.overview": "Overview",
  "common.packages.combo": "Policy Packages",
  "common.packages.received": "Packages Received",
  "common.packages.sent": "Packages Sent",
  "common.packages.total": "Total Packages",
  "common.packages": "Packages",
  "common.packet.logger": "Packet Logger",
  "common.packet.loss": "Packet Loss",
  "common.packets": "Packets",
  "common.page.not.found.message": "The page you are looking for could not be found.",
  "common.page.not.found": "Page Not Found",
  "common.page": "Page",
  "common.passive": "Passive",
  "common.password": "Password",
  "common.paste.here": "Paste Here",
  "common.pcap": "PCAP",
  "common.perHour": "per hour",
  "common.perMinute": "per minute",
  "common.permission.Denied": "Permission Denied",
  "common.perSecond": "per second",
  "common.policy": "Policy",
  "common.polPackage": "Policy Package",
  "common.port": "Port",
  "common.portuguese": "Portuguese",
  "common.position": "Position",
  "common.prefixPcap": "File Prefix",
  "common.prev": "Previous",
  "common.proceed": "Proceed",
  "common.processes": "Processes",
  "common.profile_filesize": "Maximum file size (MB)",
  "common.profile.appcontrol": "Application Control Profile",
  "common.profile.atp": "Threat Protection Profile",
  "common.profile.ips": "Intrusion Prevention Profile",
  "common.profile.sdwan": "SD-WAN Profile",
  "common.profile.ssl": "SSL Inspection Profile",
  "common.profile.webfilter.inUse": "Web Filter in Use",
  "common.profile.webfilter": "Web Filter Profile",
  "common.profile": "Profile",
  "common.profiles": "Profiles",
  "common.progress": "Progress",
  "common.protocol": "Protocol",
  "common.protocols": "Protocols",
  "common.provisioning": "Provisioning",
  "common.quantity": "Quantity",
  "common.quarantine": "Quarantine",
  "common.read": "Read",
  "common.reason": "Reason",
  "common.record": "record",
  "common.records": "records",
  "common.refresh": "Refresh",
  "common.reject": "Reject",
  "common.relevance": "Relevance",
  "common.reload.page": "Reload the Page",
  "common.reload": "Reload",
  "common.remote": "Remote",
  "common.remove": "Remove",
  "common.required.field": "Required field",
  "common.reset": "Reset",
  "common.resource.not.found": "Resource Not Found",
  "common.restore": "Restore",
  "common.retry": "Try Again",
  "common.risk": "Risk",
  "common.routes": "Routes",
  "common.rule": "Rule",
  "common.save.changes": "Save Changes",
  "common.save.error": "Error saving!",
  "common.save.success": "Successfully saved",
  "common.save": "Save",
  "common.scheduled": "Scheduled",
  "common.search": "Search",
  "common.seconds": "seconds",
  "common.secret": "Secret",
  "common.security": "Security",
  "common.select.all": "Select All",
  "common.select.device.logger": "Select Device/Logger",
  "common.select.option": "Select Option",
  "common.select.time.end": "Select End Time",
  "common.select.time.ini": "Select Start Time",
  "common.select": "Select",
  "common.selected.objects": "{count} selected",
  "common.selected": "Selected",
  "common.server.error": "Server Error",
  "common.server": "Server",
  "common.servers": "Servers",
  "common.service": "Service",
  "common.services": "Services",
  "common.session.Expired.message": "Your session has expired. Please log in again.",
  "common.session.Expired": "Session Expired",
  "common.sessions": "Sessions",
  "common.settings": "Settings",
  "common.share": "Sharing",
  "common.show.all": "Show All",
  "common.show": "Show",
  "common.sid": "SID",
  "common.simultaneous.transfers": "Simultaneous Transfers",
  "common.site": "Site",
  "common.size": "Size",
  "common.socialmedias": "Social Media",
  "common.something.Went.Wrong": "Something Went Wrong",
  "common.source": "Source",
  "common.sources": "Sources",
  "common.src": "Source",
  "common.sso": "SSO",
  "common.standalone": "Remote",
  "common.start": "Start",
  "common.state": "State",
  "common.static.routing": "Static Routing",
  "common.status": "Status",
  "common.stop": "Stop",
  "common.storage": "Storage",
  "common.storages": "Storages",
  "common.success": "Success",
  "common.sync": "Synchronization",
  "common.system.updates": "Updates",
  "common.system": "System",
  "common.task": "Task",
  "common.template.name": "Template Name",
  "common.template": "Template",
  "common.templates.combo": "Device Template",
  "common.templates": "Device Templates",
  "common.text.too.long.70c": "The value should not be more than 70 characters",
  "common.text.too.long": "Maximum character limit reached",
  "common.threat": "Threat",
  "common.time.conection": "Connection Time",
  "common.time.system": "System Time",
  "common.time": "Time",
  "common.timeout.error": "Timeout Error",
  "common.timezone": "Time Zone",
  "common.toggle": "Toggle",
  "common.top": "Top",
  "common.total": "Total",
  "common.traffic.distribution": "Traffic Distribution",
  "common.traffic": "Traffic",
  "common.transparent": "Transparent",
  "common.try.again.later": "Try Again Later",
  "common.type": "Type",
  "common.unableto.perform.Operation.message": "Unable to perform the requested operation. Try again later.",
  "common.unableto.perform.Operation": "Unable to Perform Operation",
  "common.unavaible": "Unavailable",
  "common.unblock": "Unblock",
  "common.unblocked": "Unblocked",
  "common.unexpected.Behaviour.message": "Unexpected behaviour occurred. Please try again.",
  "common.unexpected.Behaviour": "Unexpected Behaviour",
  "common.unexpected.error": "Unexpected Error",
  "common.unexpected.Response": "Unexpected Response",
  "common.unit": "Organizational Unit",
  "common.unknown": "Unknown",
  "common.unlimited": "Unlimited",
  "common.update": "Update",
  "common.updates": "Updates",
  "common.uptime": "Uptime",
  "common.used": "Usage",
  "common.user.agent": "Platform",
  "common.user": "User",
  "common.users.profiles": "User Profiles",
  "common.users": "Users",
  "common.uuid": "UUID",
  "common.values": "Values",
  "common.vdom": "Virtual Domains",
  "common.version": "Version",
  "common.view": "View",
  "common.virtualAddress": "Virtual Address",
  "common.virtualDomain": "Virtual Domain",
  "common.vpn": "VPN",
  "common.warning_all": "Warn All",
  "common.warning": "Warning",
  "common.whitelist": "Allowed Addresses",
  "common.wizard.admin.repass.mismatch": "Passwords do not match",
  "common.wizard.network.dns.error": "DNS Server {number} is required",
  "common.wizard.network.dns": "DNS Server {number}",
  "common.workers": "Workers",
  "common.working": "Processing...",
  "common.write": "Write",
  "common.years": "Years",
  "common.yes": "Yes",
  "common.zone": "Zone",
  "error.badGateway": "Incorrect or temporarily unavailable gateway.",
  "error.conflict": "Conflict. Duplicate data.",
  "error.contentValidation": "Content validation error.",
  "error.continue": "Continuing...",
  "error.createdRequest": "Request successfully created.",
  "error.default": "Standard Error",
  "error.defaultError": "An unexpected error occurred.",
  "error.defaultErrorWithCode": "Error {{code}}. An unexpected error occurred.",
  "error.file.notfound.message": "The requested file could not be found.",
  "error.file.notfound": "File Not Found",
  "error.file.upload.failed.message": "File upload failed. Please try again.",
  "error.file.upload.failed": "File Upload Failed",
  "error.forbidden": "Forbidden access. You do not have permission for this action.",
  "error.gatewayTimeout": "Response time exceeded. Try again later.",
  "error.generic": "Generic Error",
  "error.gone": "Resource no longer available.",
  "error.internal.server.error": "Internal server error. Try again later.",
  "error.invalid.credentials.message": "The credentials provided are invalid. Try again.",
  "error.invalid.credentials": "Invalid Credentials",
  "error.invalid.input": "Invalid Input",
  "error.legal.access.denied": "Resource access denied for legal reasons.",
  "error.moved.permanently": "Page moved permanently. Redirecting...",
  "error.moved.temporarily": "Page moved temporarily. Redirecting...",
  "error.network.error": "Network error. Check your Internet connection.",
  "error.no.internet.connection": "No Internet Connection",
  "error.no.content": "Successful request, but no content.",
  "error.not.found": "Page not found.",
  "error.not.implemented": "Functionality not implemented.",
  "error.not.modified": "Request not modified (caching).",
  "error.partial.content": "Request partially fulfilled.",
  "error.precondition.failed": "Precondition failed.",
  "error.processing": "Processing (WebDAV) being executed in the background.",
  "error.protocol.interaction": "Protocol interaction (WebDAV).",
  "error.proxy.authentication": "Proxy authentication required.",
  "error.redirect": "Redirecting (maintain the original method).",
  "error.requested.range.not.satisfiable": "Request range not satisfiable.",
  "error.seeOther": "See another URI. Redirecting...",
  "error.service.unavailable": "Service unavailable. Try again later.",
  "error.session.expired": "Session Expired",
  "error.success.request": "Successful request.",
  "error.teapot": "Sorry, I am a teapot.",
  "error.too.many.requests": "Too many requests.",
  "error.unauthorized": "Unauthorized. Log in to access.",
  "error.unexpected.Response.message": "We received an unexpected response from the server. Try again later.",
  "error.unexpected.Response": "Unexpected Response",
  "error.unknown": "Unknown Error",
  "module.download": "Download",
  "module.info.download": "Please download and run it, then click on Reload Page.",
  "module.notfound": "It seems that you still do not have the module: ",
  "warning.unsupported.Browser.message": "Please update your browser to a newer version for a better user experience.",
  "warning.unsupported.Browser": "Unsupported Browser",
  "warningPage.subTitle": "Sorry, this page is not available on screens smaller than 600px.",
  "warningPage.title": "Screen Too Small"  
}

export default enUS;